import _ from 'lodash';

import {
  QueryThirdPartyAccountsFilterInput,
  useThirdPartyAccountActivityLazyQuery
} from 'generated/graphql';

import { listQueryUtil } from 'iron-forge-react-modules';
import * as types from './types';



const useListQuery = listQueryUtil.genUseListQuery<types.IColumnId>();



export interface IAccount {
  id: string;
  name: string;
  accountNumber: string;
  carrierType: string;
  address: string;
  addressee: string;
  attention: string;
}

export interface IData {
  accounts: IAccount[];
}

export function useQuery() {
  return useListQuery({
    useLazyQuery: useThirdPartyAccountActivityLazyQuery,
    clientColumn2GqlSortField: {},
    defaultFilterArgs: {},
    gqlResultData2GqlPageInfo: gql => gql?.thirdPartyAccounts.pageInfo,
    genFilter2GqlFilter: () => __filter2GqlFilter,
    gqlResultData2TupleData: (gql): IData => ({
      accounts: _.map(gql.data?.thirdPartyAccounts.nodes ?? [], (node): IAccount => ({
        id: node.id,
        accountNumber: node.accountNumber,
        name: node.name,
        carrierType: node.carrierType,
        addressee: node.addressee,
        attention: node.attention,
        address: _.join(_.compact([
          node.address.street1,
          node.address.street2,
          node.address.city,
          node.address.usState,
          node.address.postalCode
        ]))
      }))
    })
  });
}



function __filter2GqlFilter(filter?: types.IFilter): QueryThirdPartyAccountsFilterInput {
  return {
    omniFreeText: filter?.searchText
  };
}
